/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    BarChart3,
    BrainCircuit,
    Activity,
    Briefcase,
    ShieldCheck,
    Database
} from "lucide-react";

export default function StatsSection() {

    const stats = [

        {
            icon: Database,
            value: "500+",
            label: "Stocks Covered",
            desc: "Indian equity universe monitored continuously"
        },

        {
            icon: Activity,
            value: "Real-Time",
            label: "Market Data",
            desc: "Live tracking of indices, sectors and derivatives"
        },

        {
            icon: BarChart3,
            value: "50+",
            label: "Analytics Modules",
            desc: "Technical, fundamental and quantitative analytics"
        },

        {
            icon: Briefcase,
            value: "Multi-Asset",
            label: "Coverage",
            desc: "Equities, derivatives, mutual funds and fixed income"
        },

        {
            icon: BrainCircuit,
            value: "AI",
            label: "Research Engine",
            desc: "Intelligent insights and screening tools"
        },

        {
            icon: ShieldCheck,
            value: "Risk",
            label: "Management",
            desc: "Scenario analysis, VaR and portfolio monitoring"
        }
    ];

    return (

        <section className="mb-24">

            <div className="text-center mb-12">

                <h2 className="
                    text-4xl
                    font-bold
                    text-slate-900
                    mb-4
                ">
                    Platform At A Glance
                </h2>

                <p className="
                    text-slate-600
                    text-lg
                    max-w-3xl
                    mx-auto
                ">
                    A unified ecosystem for analytics, research,
                    portfolio management and investment intelligence.
                </p>

            </div>

            <div className="
                grid
                md:grid-cols-2
                xl:grid-cols-3
                gap-6
            ">

                {stats.map((stat, idx) => {

                    const Icon = stat.icon;

                    return (

                        <div
                            key={idx}
                            className="
                                bg-white
                                border
                                border-slate-200
                                rounded-3xl
                                p-8
                                shadow-sm
                                hover:shadow-xl
                                transition-all
                                duration-300
                            "
                        >

                            <div className="
                                flex
                                items-center
                                justify-between
                                mb-6
                            ">

                                <Icon
                                    size={32}
                                    className="text-blue-600"
                                />

                                <span className="
                                    text-2xl
                                    font-bold
                                    text-slate-900
                                ">
                                    {stat.value}
                                </span>

                            </div>

                            <h3 className="
                                text-xl
                                font-semibold
                                text-slate-900
                                mb-2
                            ">
                                {stat.label}
                            </h3>

                            <p className="
                                text-slate-600
                                leading-relaxed
                            ">
                                {stat.desc}
                            </p>

                        </div>

                    );
                })}

            </div>

        </section>

    );
}